<div class="cv-notification-update">
    <div class="alert action-close" [ngClass]="alertClass" [@animation]="animationState" (click)="onUpdate()">
        <div class="message">
            <div class="update-icon__container">
                <i class="fas fa-redo-alt"></i>
            </div>
            <span class="update-title item-title">{{title}}</span> <br />
            <span class="item-value">{{message}}</span>
        </div>
    </div>
</div>
